G.PartCacher = function() {

	Phaser.Group.call(this,game);
	
	this.active = false;	
	
	this.every = 1;

	this.rt = game.add.renderTexture(10,10);

	this.frameCounter = 0;

	this.framesToRecord = null;

};

G.PartCacher.prototype = Object.create(Phaser.Group.prototype);

G.PartCacher.prototype.update = function() {

	if (!this.active) return;

	this.stepForward();

	if (!this.checkChildren()) {
		this.active = false;
		this.removeAll(true,true);
		return;
	}

	if (this.frameCounter % this.frameRate === 0) {
		this.saveFrame();
		this.frameNr++;

		if (this.framesToRecord !== null){
			this.framesToRecord--;
			if (this.framesToRecord == 0) this.active = false;
		}

	}
	this.frameCounter++;

};

G.PartCacher.prototype.stepForward = function() {
	
	for (var i = this.children.length; i--; ) {
		this.children[i].update();
	}

};

G.PartCacher.prototype.start = function(fileName,frameRate,nrOfFrames){ 

	this.fileName = fileName;
	this.frameNr = 0;
	this.frameRate = 60/frameRate;
	this.active = true;
	this.frameCounter = 0;

	this.framesToRecord = nrOfFrames || null;

};

G.PartCacher.prototype.saveFrame = function() {

	var bounds = this.getBounds();

  var widthFromCenter = Math.max(this.x-bounds.x,bounds.x+bounds.width-this.x,400);
  var heightFromCenter = Math.max(this.y-bounds.y,bounds.y+bounds.height-this.y,400);
  this.rt.resize(widthFromCenter*2, heightFromCenter*2, true);
  this.rt.renderXY(this, widthFromCenter, heightFromCenter, true);

  var c = this.rt.getCanvas();
  var fileName = this.fileName+'_'+this.frameNr;

  c.toBlob(function(blob) {
    saveAs(blob, fileName);
	});

};

G.PartCacher.prototype.checkChildren = function() {

	var inactive = this.children.filter(function(child) {
		return !child.alive || child.alpha === 0 || child.scale.x == 0 || child.scale.y == 0; 
	});

	return this.children.length !== inactive.length;

};